import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import Header from '../../organisms/shared/header/Header';
import Footer from '../../organisms/shared/footer/Footer';
import { Stack } from '../../atoms/stack/Stack';
import { Typography } from '../../atoms/typography/Typography';
import HeaderCard from '../../molecules/systemGuide/headerCard/HeaderCard';
import CounterSection from '../../organisms/systemGuide/counterSection/CounterSection';
import { getDataByType } from '../../../utils/utils';
import Testimonials from '../../organisms/shared/testimonials/Testimonials';
import SystemGuideSection from '../../organisms/systemGuide/systemGuideSection/SystemGuideSection';
import { InfoSection } from '../../organisms/category/infoSection/InfoSection';
import { LinkButton } from '../../atoms/linkButton/LinkButton';
import { ExtendedBackgroundContainer } from '../../atoms/extendedBackgroundContainer/ExtendedBackgroundContainer';

export const SystemGuide = ({
  hero,
  sections,
  menu,
  t,
  footer,
  siteUrls,
  location,
  locale,
  search,
}) => {
  const counterSection = sections.find(
    (el) => el.component && el.component.componentType === 'guideProcess'
  ).component;
  const testimonialsSection = getDataByType(sections, 'testimonials');
  const guideSection = getDataByType(sections, 'guideHowItWorks');
  const infoSection = getDataByType(sections, 'textSections');
  const guideControls = getDataByType(sections, 'guideControls').componentData;

  const [selectedSize, setSelectedSize] = useState(null);

  const handleStartGuide = () => {
    guideControls.onOpenGuide(selectedSize);
  };

  const showInfoSection = infoSection?.enabled;

  return (
    <div className="bg-primary-50 overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header
        // title="Va vi gör"
        headerTextStyled={!!hero.titleStyled}
        headerText={hero.title}
        isLargeWidth
        isBigCard
        card={
          <HeaderCard
            title={t('systemguide.headerCard.title')}
            subtitle={t('systemguide.headerCard.subtitle')}
            options={['1-10', '11-100', '101-500', '500+']}
            selectedOption={selectedSize}
            setSelectedOption={setSelectedSize}
            action={handleStartGuide}
            // texts={[
            //   t('systemguide.headerCard.text1'),
            //   t('systemguide.headerCard.text2'),
            // ]}
            buttonText={t('systemguide.headerCard.button')}
            t={t}
          />
        }
        headerContent={
          <Stack className="gap-3 md:gap-6">
            {hero.preambleStyled && (
              <div
                className="flex flex-col gap-3 md:gap-6 text-clamp-p2 font-normal leading-tight !text-white"
                dangerouslySetInnerHTML={{ __html: hero.preamble }}
              />
            )}
            {!hero.preambleStyled && (
              <Typography
                textAlign="left"
                fontVariant="p2"
                className="font-normal leading-tight !text-white"
              >
                {hero.preamble}
              </Typography>
            )}
            <Typography
              textAlign="left"
              fontVariant="p2"
              className="font-normal leading-tight !text-white"
            >
              {hero.guideRunsText}
            </Typography>
          </Stack>
        }
      />
      <main>
        <CounterSection section={counterSection} />
        <Testimonials section={testimonialsSection} />
        {!showInfoSection && <SystemGuideSection section={guideSection} />}
        {showInfoSection && (
          <>
            <ExtendedBackgroundContainer />
            <div className="bg-white w-full pb-20">
              <h2 className="text-center text-2xl font-bold">
                {infoSection.title}
              </h2>
              <InfoSection
                section={infoSection}
                classNames="!my-0"
                titleH="h3"
              />
              <div className="flex justify-center">
                <LinkButton
                  className="w-fit mt-3"
                  size="xl"
                  variant="primary-filled"
                  textTransform="uppercase"
                  href={infoSection.actionButtonHref}
                  label={infoSection.actionButtonText}
                  onClick={infoSection.onActionButtonClick}
                />
              </div>
            </div>
          </>
        )}
      </main>

      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

SystemGuide.propTypes = {
  hero: PropTypes.object,
  sections: PropTypes.array,
};
